export const LAYOUT_RESIZED = 'LAYOUT_RESIZED'
export const MENU_CLOSED = 'MENU_CLOSED'
export const MENU_TOGGLED = 'MENU_TOGGLED'
export const EXPAND_TOGGLED = 'EXPAND_TOGGLED'
export const MAP_LEFT_EDGE_CHANGED = 'MAP_LEFT_EDGE_CHANGED'
export const APP_DID_MOUNT = 'APP_DID_MOUNT'
export const SEARCH_TOGGLED = 'SEARCH_TOGGLED'
export const COLLAPSE_LAYOUT = 'COLLAPSE_LAYOUT'
